export type LedgerDocumentEntryType =
  | 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO'
  | 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH'
  | 'BUT_TOAN_HUY'
  | 'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO'
  | 'CHUNG_TU_PHAI_TRA_KHAC'
  | 'GIAY_BAO_CO'
  | 'GIAY_BAO_NO'
  | 'HOA_DON_BAN_DICH_VU'
  | 'HOA_DON_BAN_HANG'
  | 'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA'
  | 'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP'
  | 'HOA_DON_DIEU_CHINH_GIA_HANG_BAN'
  | 'HOA_DON_MUA_DICH_VU'
  | 'HOA_DON_MUA_HANG_TRONG_NUOC'
  | 'PHIEU_CHI'
  | 'PHIEU_KE_TOAN'
  | 'PHIEU_KE_TOAN_THEO_NGHIEP_VU'
  | 'PHIEU_NHAP_CHI_PHI_MUA_HANG'
  | 'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA'
  | 'PHIEU_NHAP_DIEU_CHUYEN'
  | 'PHIEU_NHAP_HANG_BAN_TRA_LAI'
  | 'PHIEU_NHAP_KHO'
  | 'PHIEU_THANH_TOAN_TAM_UNG'
  | 'PHIEU_THU'
  | 'PHIEU_XUAT_DIEU_CHUYEN'
  | 'PHIEU_XUAT_KHO'
  | 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP';

export interface LedgerDocumentEntryState {
  documentUuid: string;
  documentType: string;
  entryType: LedgerDocumentEntryType;
}

const DOCUMENT_ENTRY_TYPE_BY_CODE: Record<string, LedgerDocumentEntryType> = {
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO: 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO',
  ButToanDieuChinhGiamCongNoModel: 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO',
  BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH: 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH',
  ButToanDieuChinhGiamCongNoMuaHangModel: 'BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH',
  BUT_TOAN_HUY: 'BUT_TOAN_HUY',
  ButToanHuyModel: 'BUT_TOAN_HUY',
  BUT_TOAN_KET_CHUYEN: 'GIAY_BAO_CO',
  ButToanKetChuyenKeToanModel: 'GIAY_BAO_CO',
  CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO: 'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO',
  ChungTuPhaiThuKhacChungTuBuTruCongNoModel: 'CHUNG_TU_PHAI_THU_KHAC_CHUNG_TU_BU_TRU_CONG_NO',
  CHUNG_TU_PHAI_TRA_KHAC: 'CHUNG_TU_PHAI_TRA_KHAC',
  ChungTuPhaiTraKhacChungTuBuTruCongNoModel: 'CHUNG_TU_PHAI_TRA_KHAC',
  GIAY_BAO_CO: 'GIAY_BAO_CO',
  GiayBaoCoModel: 'GIAY_BAO_CO',
  GIAY_BAO_NO: 'GIAY_BAO_NO',
  BankTransferDocumentModel: 'GIAY_BAO_NO',
  HOA_DON_BAN_DICH_VU: 'HOA_DON_BAN_DICH_VU',
  HoaDonDichVuModel: 'HOA_DON_BAN_DICH_VU',
  HOA_DON_BAN_HANG: 'HOA_DON_BAN_HANG',
  HoaDonBanHangIposModel: 'HOA_DON_BAN_HANG',
  HoaDonBanHangModel: 'HOA_DON_BAN_HANG',
  HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA: 'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA',
  HoaDonDichVuTraLaiGiamGiaModel: 'HOA_DON_DICH_VU_TRA_LAI_GIAM_GIA',
  HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP: 'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP',
  HoaDonDichVuTraLaiNhaCungCapModel: 'HOA_DON_DICH_VU_TRA_LAI_NHA_CUNG_CAP',
  HOA_DON_DIEU_CHINH_GIA_HANG_BAN: 'HOA_DON_DIEU_CHINH_GIA_HANG_BAN',
  HoaDonDieuChinhGiaHangBanModel: 'HOA_DON_DIEU_CHINH_GIA_HANG_BAN',
  HOA_DON_MUA_DICH_VU: 'HOA_DON_MUA_DICH_VU',
  HoaDonMuaDichVuModel: 'HOA_DON_MUA_DICH_VU',
  HOA_DON_MUA_HANG_TRONG_NUOC: 'HOA_DON_MUA_HANG_TRONG_NUOC',
  HoaDonMuaHangTrongNuocModel: 'HOA_DON_MUA_HANG_TRONG_NUOC',
  PHIEU_CHI: 'PHIEU_CHI',
  PhieuChiModel: 'PHIEU_CHI',
  PHIEU_KE_TOAN: 'PHIEU_KE_TOAN',
  PhieuKeToanModel: 'PHIEU_KE_TOAN',
  PHIEU_KE_TOAN_THEO_NGHIEP_VU: 'PHIEU_KE_TOAN_THEO_NGHIEP_VU',
  PhieuKeToaNghiepVuModel: 'PHIEU_KE_TOAN_THEO_NGHIEP_VU',
  PHIEU_NHAP_CHI_PHI_MUA_HANG: 'PHIEU_NHAP_CHI_PHI_MUA_HANG',
  PhieuNhapChiPhiMuaHangModel: 'PHIEU_NHAP_CHI_PHI_MUA_HANG',
  PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA: 'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA',
  PhieuNhapDieuChinhGiaHangMuaModel: 'PHIEU_NHAP_DIEU_CHINH_GIA_HANG_MUA',
  PHIEU_NHAP_DIEU_CHUYEN: 'PHIEU_NHAP_DIEU_CHUYEN',
  PhieuNhapDieuChuyenModel: 'PHIEU_NHAP_DIEU_CHUYEN',
  PHIEU_NHAP_HANG_BAN_TRA_LAI: 'PHIEU_NHAP_HANG_BAN_TRA_LAI',
  PhieuNhapHangBanTraLaiModel: 'PHIEU_NHAP_HANG_BAN_TRA_LAI',
  PHIEU_NHAP_KHO: 'PHIEU_NHAP_KHO',
  PhieuNhapKhoModel: 'PHIEU_NHAP_KHO',
  PHIEU_THANH_TOAN_TAM_UNG: 'PHIEU_THANH_TOAN_TAM_UNG',
  PhieuThanhToanTamUngModel: 'PHIEU_THANH_TOAN_TAM_UNG',
  PHIEU_THU: 'PHIEU_THU',
  PhieuThuModel: 'PHIEU_THU',
  PHIEU_XUAT_DIEU_CHUYEN: 'PHIEU_XUAT_DIEU_CHUYEN',
  PhieuXuatDieuChuyenModel: 'PHIEU_XUAT_DIEU_CHUYEN',
  PHIEU_XUAT_KHO: 'PHIEU_XUAT_KHO',
  PhieuXuatKhoModel: 'PHIEU_XUAT_KHO',
  PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP: 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP',
  PhieuXuatTraLaiNhaCungCapModel: 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP'
};

const readString = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

export const resolveLedgerDocumentEntry = (row: MuaHangRecord): LedgerDocumentEntryState | null => {
  if (!row || typeof row !== 'object') return null;

  const documentUuid = readString(row.document_uuid) || readString(row.uuid);
  const documentType = readString(row.document_type) || readString(row.ma_ct);
  const soCt = readString(row.so_ct) || readString(row.so_ct0);
  const entryType = DOCUMENT_ENTRY_TYPE_BY_CODE[documentType];

  if (!documentUuid || !documentType || !soCt || !entryType) {
    return null;
  }

  return {
    documentUuid,
    documentType,
    entryType
  };
};
